@if (widgetConfig) {
  <div class="drawer-container">
    <div class="header">
      <div class="header-groups">
          <div class="header-right-group">
              <button class="icon-button back-button" (click)="close()">
                  <img [src]="'svg/arrow-left.svg' | assetVersion" alt="" />
              </button>
              <div class="header-title-container">
                  <app-polaris-icon class="polaris-icon"></app-polaris-icon>
                  <span class="title">Ask {{ polarisName }}</span>
                  <span class="separator">|</span>
                  <span class="context-title">{{ widgetConfig.name }}</span>
              </div>
          </div>
          <div class="header-left-group">
              <button class="icon-button close-button" (click)="close()">
                  <img [src]="'svg/closeX.svg' | assetVersion" alt="" />
              </button>
          </div>
      </div>
    </div>
    <div class="content">
      <section class="section">
        <span class="section-title">Things to look into</span>
        <div class="question-cards">
          @for (question of widgetQuestions; track question) {
            <button type="button" class="question-card" (click)="onQuestionClicked(question)">
              {{ question }}
            </button>
          }
        </div>
      </section>
      <section class="section">
        <span class="section-title">Or ask your own question</span>
        <textarea
          id="custom-question-input"
          class="custom-question-input"
          type="text"
          placeholder="Ask me anything about this widget's data"
          [formControl]="customQuestionFormControl"
        ></textarea>
        <button type="button" class="send-button" [disabled]="customQuestionFormControl.invalid" (click)="onSend()">
          Send
          <img [src]="'svg/send.svg' | assetVersion" alt="" />
        </button>
      </section>
      </div>
  </div>
}